import React, { useState, useRef, useEffect } from 'react';
import { useTenant } from '../../context/TenantContext';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function TenantSwitcher() {
  const { activeTenant, tenants, switchTenant } = useTenant();
  const { tenants: authTenants } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref  = useRef(null);
  const list = tenants.length ? tenants : (authTenants || []);

  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', fn);
    return () => document.removeEventListener('mousedown', fn);
  }, []);

  if (!list.length) return null;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '5px 10px', cursor: 'pointer', fontSize: 13 }}>
        <span style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{activeTenant?.name || 'Select Workspace'}</span>
        <span style={{ color: 'var(--text-3)', fontSize: 10 }}>▾</span>
      </button>
      {open && (
        <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: 4, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, minWidth: 220, zIndex: 999, boxShadow: '0 8px 24px #0005', padding: 6 }}>
          <div style={{ fontSize: 10, color: 'var(--text-3)', padding: '6px 10px', letterSpacing: 1, fontWeight: 600 }}>YOUR WORKSPACES</div>
          {list.map(t => (
            <button key={t.id} onClick={() => { switchTenant(t, t.my_role || t.tenant_role); setOpen(false); navigate('/tenant'); }}
              style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '8px 10px', background: activeTenant?.id === t.id ? 'var(--accent)20' : 'transparent', border: 'none', borderRadius: 7, cursor: 'pointer', textAlign: 'left' }}>
              <div style={{ width: 26, height: 26, borderRadius: 6, background: 'linear-gradient(135deg,var(--accent),#7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#fff', flexShrink: 0 }}>{t.name?.[0]?.toUpperCase()}</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500 }}>{t.name}</div>
                <div style={{ fontSize: 10, color: 'var(--text-3)' }}>{(t.my_role || t.tenant_role)?.replace('_', ' ')}</div>
              </div>
              {activeTenant?.id === t.id && <span style={{ marginLeft: 'auto', color: 'var(--accent)', fontSize: 12 }}>✓</span>}
            </button>
          ))}
          <div style={{ borderTop: '1px solid var(--border)', margin: '4px 0' }} />
          <button onClick={() => { setOpen(false); navigate('/onboarding'); }}
            style={{ width: '100%', padding: '8px 10px', background: 'transparent', border: 'none', borderRadius: 7, cursor: 'pointer', textAlign: 'left', fontSize: 13, color: 'var(--text-2)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>＋</span> Create new workspace
          </button>
        </div>
      )}
    </div>
  );
}
